import { render, staticRenderFns } from "./SupporterEditAddress.vue?vue&type=template&id=2d8a642a&"
import script from "./SupporterEditAddress.vue?vue&type=script&lang=js&"
export * from "./SupporterEditAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports